// Test IDs de componentes compartidos.

export const SIGNATURE = {
  canvas: 'patient-consent-modal-signature-canvas',
  clear: 'patient-consent-modal-signature-clear',
};
